module.exports = __webpack_public_path__ + "static/media/sudoku5.d9ad8197.png";